import Type from './type';

export default {
	isString: (value) => {
		return Object.prototype.toString.call(value) === '[object String]' && value.constructor === String;
	},
	isWhiteSpace: (value) => {
		return String.prototype.toString.call(value).trim() === '';
	},
	isNullOrEmpty: (value) => {
		if (Type.isNullOrUndefined(value)) {
			return true;
		}

		return value.toString().trim().length === 0;
	},
	isNullOrWhiteSpace: (value) => {
		if (Type.isNullOrUndefined(value)) {
			return true;
		}

		return String(value).trim() === '';
	},
	toLowerCaseFirstLetter: (word) => {
		const [firstChar, ...otherChars] = word.split('');

		return firstChar.toLowerCase().concat(otherChars.join(''));
	},
};
